import { Component, Inject } from '@angular/core';
import { CanvasService } from '../../canvas.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/common/auth.service';
import { SnackbarService } from 'src/app/services/common/snackbar.service';

@Component({
  selector: 'app-canvas-chat-feedback-dialog',
  templateUrl: './canvas-chat-feedback-dialog.component.html',
  styleUrl: './canvas-chat-feedback-dialog.component.scss',
})
export class CanvasChatFeedbackDialogComponent {
  description: string = '';
  isSubmitted: boolean = false;
  isFeedbackSubmitted: boolean = false;
  viewMode: boolean = false;

  get showNegativeOptions(): boolean {
    return !this.data?.isPositiveFeedback;
  }

  feedbackOptions: any = {
    wrongInformation: false,
    outdatedData: false,
    unauthorizedContent: false,
    notRelevant: false,
    confusing: false,
    complexAnswer: false,
    other: false,
  };

  constructor(
    private readonly snack: SnackbarService,
    private readonly hubService: CanvasService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly auth: AuthService,
    private readonly dialogRef: MatDialogRef<CanvasChatFeedbackDialogComponent>
  ) {}

  ngOnInit() {
    const responseItem = this.data?.currentChatResponseItem;
    if (responseItem?.feedback != null) {
      this.viewMode = true;
      this.data.isPositiveFeedback =
        responseItem.feedback.feedback_type === 'positive';
      this.description = responseItem.feedback.feedback_text;
      if (
        !this.data.isPositiveFeedback &&
        responseItem.feedback.categories?.length > 0
      ) {
        responseItem.feedback.categories.forEach((category: string) => {
          if (category in this.feedbackOptions) {
            this.feedbackOptions[category] = true;
          }
        });
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  submitFeedbackComment() {
    if (this.viewMode) {
      this.closeDialog();
      return;
    }

    if (this.isFeedbackSubmitted) {
      return;
    }

    this.isFeedbackSubmitted = true;
    const categories = this.showNegativeOptions
      ? Object.entries(this.feedbackOptions)
          .filter(([_, value]) => value)
          .map(([key]) => key)
      : [];

    const payload = {
      session_id: this.data.chatDetails.session_id,
      conversation_id: this.data.chatDetails._id,
      response_id: this.data.currentChatResponseItem.id,
      feedback_type: this.data?.isPositiveFeedback ? 'positive' : 'negative',
      feedback_text: this.description,
      categories: categories,
    };
    this.hubService.sendComment(payload).subscribe({
      next: (response: any) => {
        this.isFeedbackSubmitted = false;
        if (response?.message) {
          this.isSubmitted = true;
          if (this.data.currentChatResponseItem) {
            this.data.currentChatResponseItem.feedback = {
              feedback_id: response.feedback_id,
              feedback_type: payload.feedback_type,
              feedback_text: payload.feedback_text,
              categories: payload.categories,
            };
          }

          setTimeout(() => {
            this.dialogRef.close({
              success: true,
              feedback: this.data.currentChatResponseItem.feedback,
            });
          }, 2000);
        }
      },
      error: (error: any) => {
        console.log(error);
        this.snack.openErrorBar('Failed to submit feedback');
        this.isFeedbackSubmitted = false;
      },
    });
  }
}
